import styled from 'styled-components';
import { textTinyNormal } from '../../Typography';

export const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: var(--space-75) var(--space-150);
  align-items: center;
  gap: var(--space-100);
  align-self: stretch;

  svg.prefix-icon {
    path {
      color: var(--black-800);
    }
  }

  border: 1px solid var(--border-color-default);
  border-radius: var(--radius-400);
  background: var(--button-background);

  .pill-item {
    display: inline-flex;
    align-items: center;
    padding: var(--space-75);
    border: 1px solid var(--border-color-secondary);
    border-radius: var(--radius-200);
    background-color: var(--black-500);
    color: var(--black-800);
    max-width: 300px;
    height: 24px;
    ${textTinyNormal};
    gap: var(--space-50);

    &.has-warning {
      border-color: var(--orange-200);

      span {
        color: var(--orange-200);
      }

      svg {
        path {
          color: var(--orange-200);
        }
      }
    }

    span {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .info-icon-container {
      display: flex;
      align-items: center;
    }
  }
`;
